import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Fab, Grid, Typography, withWidth} from "@material-ui/core";
import {ArrowForward} from '@material-ui/icons';
import {isWidthUp} from '@material-ui/core/withWidth';

const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 12,
    background: `linear-gradient(90deg,  ${theme.palette.secondary.dark} 30%, ${theme.palette.secondary.main} 90%)`,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing.unit * 6,
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 4
    }
  },
  tryNowButtonContainer: {
    alignSelf: 'center'
  },
  tryNowButton: {
    fontSize: theme.spacing.unit * 1.5,
    marginTop: theme.spacing.unit * 2,
    fontWeight: 'bold',
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2
  }
});

const TryDemo = withStyles(styles)(({classes, width}) => (
  <div className={classes.root}>
    <Grid container direction="column" alignItems="center" justify="center">
      <Grid item>
        <Typography variant={isWidthUp('md', width, false) ? 'h3' : 'h4'} gutterBottom align="center">
          You should try our
          <span style={{fontWeight: 'bold'}}> Demo Version!</span>
        </Typography>
      </Grid>
      <Grid item className={classes.tryNowButtonContainer}>
        <Fab variant="extended" size="large" color="primary" className={classes.tryNowButton}>
          Try Now
          <ArrowForward fontSize="small"/>
        </Fab>
      </Grid>
    </Grid>
  </div>
));

export default withWidth()(TryDemo);
